import { Customer, Invoice, InvoiceSummary, Order } from 'olo-service';
import { DetailedCartItem } from 'hooks/context/cart';
import { fromCents, toCents } from 'util/Formatting';
import { MinifiedItem, GiftCardItem } from 'olo-service/models';

export type CheckoutCart = {
  tipValue: number;
  customer: Customer;
  cartItems: DetailedCartItem[];
  giftCards: GiftCardItem[];
  note?: string;
  globalCustomerUuid?: string;
}

export const minifyCart = (items: DetailedCartItem[]) => items.reduce((itemArray: MinifiedItem[], { id, modifiers, note, quantity }) => itemArray.concat(
  [...new Array(quantity)].map(() => ({
    id,
    note,
    itemModifiers: modifiers.map(({ id }) => ({ id }))
  }))
), []);

export const processGiftCards = (items: GiftCardItem[]): GiftCardItem[] => items.map(({ amount, recipient, ...item }) => ({
  ...item,
  amount: toCents(amount),
  recipient: recipient.isCustomer ? { isCustomer: true } : recipient,
}));

export const formatRequest = ({ cartItems, giftCards, tipValue = 0, ...cart }: Partial<CheckoutCart>): Partial<Order> => ({
  cart: {
    items: minifyCart(cartItems ?? []),
    giftCards: processGiftCards(giftCards ?? []),
  },
  tipAmount: toCents(tipValue),
  ...cart
});

export const formatSummary = ({ subtotal, total, totalTaxAmount, serviceCharge, surchargeAmount, applicablePerks, lineItems, discounts, deliveryFee, orderFee, giftSources, giftRedemptionAmount }: Invoice): InvoiceSummary => ({
  subtotal: fromCents(subtotal),
  total: fromCents(total),
  tax: fromCents(totalTaxAmount),
  serviceCharge: fromCents(serviceCharge),
  lineItems,
  orderFee: (orderFee || orderFee === 0) ? fromCents(orderFee) : undefined,
  discounts,
  surchargeAmount,
  applicablePerks,
  deliveryFee: deliveryFee ? fromCents(deliveryFee) : undefined,
  giftSources,
  giftRedemptionAmount: giftRedemptionAmount ? fromCents(giftRedemptionAmount) : undefined
});
